<template>
  <div>
    <AlertWraper
      :content="errors"
      type="error"
    />
    <form class="default-form mt-4 position-relative" @submit.prevent="submit">
      <div class="form-group default-input">
        <input type="text" class="form-control with-label" v-model.trim="$v.card.holderName.$model" placeholder="" />
        <label>Nome do portador no cartão</label>
      </div>
      <div class="form-group default-input">
        <TheMask
          :mask="'#### #### #### ####'"
          v-model.trim="$v.card.number.$model"
          placeholder=""
          class="form-control with-label"
          type="tel"
        />
        <label>Número do cartão</label>
      </div>
      <div
        class="d-lg-flex"
      >
        <div class="col-lg-6 pl-0">
          <div class="form-group default-input ">
            <TheMask
              :mask="'##/##'"
              v-model="$v.card.expirationDate.$model"
              placeholder=""
              class="form-control with-label"
            />
            <label>Data de validade</label>
          </div>
        </div>
        <div class="col-lg-6 px-0">
          <div class="form-group default-input">
            <input type="text" class="form-control with-label" v-model.trim="$v.card.cvv.$model" placeholder="" />
            <label>CVV</label>
          </div>
        </div>
      </div>
      <div class="mt-3">
        <p class="font-weight-bold">Preencha o endereço de cobrança</p>
        <div class="position-relative">
          <LoaderOverlay
            size="big"
            color="color2"
            v-if="zipcodeLoader"
          />
          <div
            class="d-lg-flex"
          >
            <div class="col-lg-4 pl-0">
              <div class="form-group default-input">
                <TheMask
                  :mask="'#####-###'"
                  v-model="$v.card.zipcode.$model"
                  placeholder=""
                  class="form-control with-label"
                  @change.native="getCep"
                />
                <label>CEP</label>
              </div>
            </div>
            <div class="col-lg-8 px-0">
              <div class="form-group default-input">
                <input type="text" class="form-control with-label" v-model.trim="$v.card.street.$model" placeholder="" readonly />
                <label>Endereço</label>
              </div>
            </div>
          </div>
          <div
            class="d-lg-flex"
          >
            <div class="col-lg-4 pl-0">
              <div class="form-group default-input">
                <input type="text" class="form-control with-label" v-model.trim="$v.card.streetNumber.$model" placeholder="" />
                <label>Número</label>
              </div>
            </div>
            <div class="col-lg-4 pl-0">
              <div class="form-group default-input">
                <input type="text" class="form-control with-label" v-model.trim="card.complement" placeholder="" />
                <label>Complemento</label>
              </div>
            </div>
            <div class="col-lg-4 px-0">
              <div class="form-group default-input">
                <input type="text" class="form-control with-label" v-model.trim="$v.card.neighborhood.$model" placeholder="" readonly />
                <label>Bairro</label>
              </div>
            </div>
          </div>
          <div
            class="d-lg-flex"
          >
            <div class="col-lg-5 pl-0">
              <div class="form-group default-input">
                <input type="text" class="form-control with-label" v-model.trim="$v.card.city.$model" placeholder="" readonly />
                <label>Cidade</label>
              </div>
            </div>
            <div class="col-lg-5 px-0">
              <div class="form-group default-input">
                <input type="text" class="form-control with-label" v-model.trim="$v.card.state.$model" placeholder="" readonly />
                <label>Estado</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-3 text-center">
        <Button
          type="submit"
          class="btn-primary"
          :disabled="$v.$invalid"
          :loading="loader"
        >
          Criar cartão
        </Button>
      </div>
    </form>
  </div>
</template>

<script>

import CreditCardsService from '@/modules/credit-cards/services/credit-cards-service'
import { required } from 'vuelidate/lib/validators'
import { getCEPData, parseErrorResponseToArray } from '@/utils'

import AlertWraper from '@/components/common/Alert/AlertWraper'
import Button from '@/components/common/Button/Button'
import LoaderOverlay from '@/components/common/Loader/LoaderOverlay'
import { TheMask } from 'vue-the-mask'

export default {
  name: 'CreditCardCreationForm',
  components: {
    AlertWraper,
    Button,
    LoaderOverlay,
    TheMask
  },
  data () {
    return {
      card: {
        number: '',
        holderName: '',
        expirationDate: '',
        cvv: '',
        street: '',
        streetNumber: '',
        zipcode: '',
        city: '',
        state: '',
        neighborhood: '',
        complement: ''
      },
      zipcodeLoader: false,
      errors: null,
      loader: false
    }
  },
  validations () {
    return {
      card: {
        number: { required },
        holderName: { required },
        expirationDate: { required },
        cvv: { required },
        street: { required },
        streetNumber: { required },
        zipcode: { required },
        neighborhood: { required },
        city: { required },
        state: { required }
      }
    }
  },
  methods: {
    async submit () {
      this.errors = null
      this.loader = true
      try {
        const card = await CreditCardsService.create(this.card)
        this.reset()
        this.$emit('credit-card-created', card)
      } catch (error) {
        this.errors = parseErrorResponseToArray(error)
      }
      this.loader = false
    },
    async getCep () {
      this.zipcodeLoader = true
      this.errors = null
      try {
        const address = await getCEPData(this.card.zipcode)
        this.$v.card.street.$model = address.street
        this.$v.card.neighborhood.$model = address.neighborhood
        this.$v.card.city.$model = address.city
        this.$v.card.state.$model = address.state
      } catch (error) {
        this.errors = parseErrorResponseToArray(error)
      }
      this.zipcodeLoader = false
    },
    reset () {
      this.errors = null
      this.card.number = ''
      this.card.holderName = ''
      this.card.expirationDate = ''
      this.card.cvv = ''
      this.card.street = ''
      this.card.streetNumber = ''
      this.card.zipcode = ''
      this.card.city = ''
      this.card.state = ''
      this.card.neighborhood = ''
      this.card.complement = ''
    }
  }
}
</script>
